export default "__VITE_ASSET__TVzQDIvu__"